import React from 'react';

const CircleExclamation: React.FC<IconProps> = ({
    height,
    width,
    fillColor,
}) => {
    const h = height ?? 20;
    const w = width ?? 20;
    const fill = fillColor ?? "#DD3100";
    return (
        <svg
            width={w}
            height={h}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99999 0.666672C3.9499 0.666672 0.666656 3.94992 0.666656 8.00001C0.666656 12.0501 3.9499 15.3333 7.99999 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 8.00001C15.3333 3.94992 12.0501 0.666672 7.99999 0.666672ZM8.66666 5.33334C8.66666 4.96515 8.36818 4.66667 7.99999 4.66667C7.6318 4.66667 7.33332 4.96515 7.33332 5.33334V8.00001C7.33332 8.36819 7.6318 8.66667 7.99999 8.66667C8.36818 8.66667 8.66666 8.36819 8.66666 8.00001V5.33334ZM7.99999 10C7.6318 10 7.33332 10.2985 7.33332 10.6667C7.33332 11.0349 7.6318 11.3333 7.99999 11.3333H8.00666C8.37485 11.3333 8.67332 11.0349 8.67332 10.6667C8.67332 10.2985 8.37485 10 8.00666 10H7.99999Z" fill={fill}/>
        </svg>
    );
};

export default CircleExclamation;